// https://roblox.atlassian.net/l/cp/Kg41JEEJ
// Events are camelCase
// Use alphabetical order
enum DocsSiteEventType {
  OpenSourceEditButtonClicked = 'docOpenSourceEditButtonClick',
  SettingsEntryPointClicked = 'docSettingsEntryPointClicked',
  OpenStudioButtonClick = 'openStudioButtonClick',
  SideBarFilterPerformed = 'sideBarFilterPerformed',
  SideBarFilterCleared = 'sideBarFilterCleared',
  TreeNodeClicked = 'treeNodeClicked',
  /** NOTE (tchu, 2025/06/14): Begin sync with CreatorDashboardEventType.ts in creator-hub
   * https://github.rbx.com/Roblox/creator-hub/blob/b90c84050c29a6641c4a0cf5ab7673df0d7f697f/apps/creator-hub/modules/eventStream/enum/CreatorDashboardEventType.ts#L9
   */
  DownloadStudio = 'downloadStudio',
  LanguageChanged = 'documentationLanguageChanged', // CreatorDashboardEventType.DocumentationLanguageChanged
  StudioStartAttempt = 'studioStartAttempt',
  StudioStartSuccess = 'studioStartSuccess',
  /** End sync with CreatorDashboardEventType.ts in creator-hub */

  TryItOutClickTryItOut = 'TryItOut_clickTryItOut',
  TryItOutClickAcceptWarning = 'TryItOut_clickAcceptWarning',
  TryItOutClickCancelWarning = 'TryItOut_clickCancelWarning',
  TryItOutClickExecute = 'TryItOut_clickExecute',
  TryItOutClickCopyCurl = 'TryItOut_clickCopyCurl',
  TryItOutClickAcceptHighRiskWarning = 'TryItOut_clickAcceptHighRiskWarning',
  TryItOutClickCancelHighRiskWarning = 'TryItOut_clickCancelHighRiskWarning',

  OpenCloudEndpointAccordionClosed = 'OpenCloud_endpointAccordionClosed',
  OpenCloudEndpointAccordionOpened = 'OpenCloud_endpointAccordionOpened',
  OpenCloudFilterChanged = 'OpenCloud_filterChanged',
  OpenCloudIAOptBackIn = 'OpenCloud_IAOptBackIn',
  OpenCloudIAOptOut = 'OpenCloud_IAOptOut',
}

export default DocsSiteEventType;
